import { toQueryString } from '@/src/utils/generalUtils/toQueryString'

export interface TripParams {
    src?: string
    isMobileApp?: string
    account?: string
}

export const getTripDetailsUrl = (tripId: string, locale: string, account?: string) => {
    const accountQuery = account === 'LINKED' ? '?account=LINKED' : ''
    return `/${locale}/trips/${tripId}${accountQuery}`
}

export const getHotelTripDetailsUrl = (tripId: string, locale: string, account?: string) => {
    const query = account === 'LINKED' ? '?account=LINKED' : ''
    return `/${locale}/trips/hotels/${tripId}${query}`
}

export const getCancellationLink = (tripId: string, params: TripParams = {}) => {
    const { src, isMobileApp, account } = params
    const accountParam = account === 'LINKED' ? '&account=LINKED' : ''

    if (src === 'home' && isMobileApp === 'true') {
        return `/accounts/trips/${tripId}/cancel?${toQueryString({ src: 'home', isMobileApp: 'true' })}${accountParam}`
    }

    if (src === 'home') {
        return `/accounts/trips/${tripId}/cancel?${toQueryString({ src: 'home' })}${accountParam}`
    }

    return `/accounts/trips/${tripId}/cancel?${toQueryString({ src: 'TDCT' })}${accountParam}`
}

export const getAmendmentLink = (tripId: string, params: TripParams = {}) => {
    const { src, isMobileApp } = params
    if (src === 'home' && isMobileApp === 'true') {
        return `/amendments/select-dates/${tripId}?${toQueryString({ src: 'home', isMobileApp: 'true' })}`
    }
    if (src === 'home') {
        return `/amendments/select-dates/${tripId}?${toQueryString({ src: 'home' })}`
    }
    return `/amendments/select-dates/${tripId}?${toQueryString({ src: 'TDCT' })}`
}

export const getPrintEreceiptUrl = (tripId: string) => `/account/trips/${tripId}/receipt`

export const getPrintEticketFormAction = () => '/ticket'

export const isFlyinTrip = (domain?: string | null): boolean =>
    !!domain && (domain === 'flyin.com' || domain.toLowerCase().includes('flyin'))

export const getTripParamsFromUrl = (): TripParams => {
    if (typeof window === 'undefined') return {}
    const params = new URLSearchParams(window.location.search)
    const src = params.get('src') || undefined
    const isMobileApp = params.get('isMobileApp') || undefined
    const account = params.get('account') || undefined
    return { src, isMobileApp, account }
}

